export default __webpack_public_path__ + "static/media/activities.7526ffdf.svg";